import { useTranslation } from 'react-i18next';
import { Button, TableItem } from 'components/atoms';
import AssetIdPopupForm from 'components/molecules/popup/asset-id-popup-form/AssetIdPopupForm';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useParamId } from 'hooks/useParamId';
import { PiTrash } from 'react-icons/pi';
import {
  useDeleteChannelAssetId,
  useGetChannelAssetIdListInfinite,
} from 'services/channel/assetId';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const ChannelAssetId = () => {
  const { t } = useTranslation();
  const channelId = useParamId('channel');

  const channelAssetsId = useGetChannelAssetIdListInfinite({ channelId });

  const removeAssetId = useDeleteChannelAssetId();

  const tableProps = useInfiniteTable(channelAssetsId);

  return (
    <TopbarPage
      topbar={
        <TopBar
          size='compact'
          hideHeader
          topbarContent={<AssetIdPopupForm />}
        />
      }>
      <Table
        id={'channel-asset-id'}
        size='compact'
        {...tableProps}
        select={undefined}
        columns={[
          {
            label: 'Asset ID',
            renderCell: ({ assetId }) => (
              <TableItem>
                <TableItem.Text text={assetId} />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: ({ id }) => (
              <TableItem justifyPosition='end'>
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={async () =>
                    await removeAssetId.mutateAsync(id, {
                      onSuccess: () => channelAssetsId.refetch(),
                      onError: error => onErrorShowAllErrorsToast(error),
                    })
                  }>
                                    <Button.Description description={t('button.remove')} />

                                    <Button.Icon icon={<PiTrash />} />
                </Button>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default ChannelAssetId;
